module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wIFAoyLJQcQLkAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAATklEQVQY08XNsQnAQAxD0X+QUVx7gFvDAxmv6Nq7OFWOQMiViUrxhOC3DIDMfAWqCsBxFRHRVbWAiODu47HMTMys55xtZr17WXiL7vibnCFkHelcbNvXAAAAAElFTkSuQmCC"


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/arrow.png
 ** module id = 241
 ** module chunks = 0 1
 **/